import sdl from '@jds/react-generated-sdl/JDSDatepickerCalendarButton';
import type { JDSDatepickerCalendarButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerCalendarButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'default',
    disabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, disabled, ...rest },
    'JDSDatepickerCalendarButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerCalendarButton = withLogic(
  Component
) as React.FC<JDSDatepickerCalendarButtonProps> & { slotName?: string };

DatepickerCalendarButton.displayName = 'DatepickerCalendarButton';
DatepickerCalendarButton.slotName = 'jds_datepicker_calendar_button';

export { DatepickerCalendarButton, type JDSDatepickerCalendarButtonProps };
